@if (log) {
  <ion-item [routerLink]="embedded ? null : ['/', 'logboek', log.id]"
    (click)="onItemClick()"
    [detail]="!embedded"
    [class.selected]="isSelected"
    class="log-item"
    [style.--accent-color]="accentColor">

    <div class="avatar-wrapper" slot="start">
      <app-show-avatar
        [imageUrl]="log.performance?.show?.imageUrl"
        [showName]="log.performance?.show?.name || 'Show'"
        size="medium">
      </app-show-avatar>
    </div>

    <ion-label class="item-content">
      <!-- Status badge -->
      @if (isConcept) {
        <ion-badge color="medium" class="status-badge">
          Concept
        </ion-badge>
      }

      <!-- Show name -->
      <h2 class="show-name">{{ log.performance?.show?.name }}</h2>

      <!-- Performance date and time -->
      <p class="performance-date">
        {{ log.performance?.datetime | date:'EEEE d MMMM y':'CEST':'nl-NL' | titlecase }}
        <span class="performance-time">{{ log.performance?.datetime | date:'HH:mm':'CEST':'nl-NL' }}</span>
      </p>

      <!-- Toneelmeester name -->
      @if (toneelmeesterName) {
        <p class="toneelmeester">
          <ion-icon name="person-outline"></ion-icon>
          {{ toneelmeesterName }}
        </p>
      }
    </ion-label>
  </ion-item>
}
